<template>
  <!-- <a-modal 
    :title="title"
    :visible="visible.raw"
    v-if="visible.raw"
    @ok="ok" 
    @cancel="cancel"
    :bodyStyle="modalBodyStyle"
    :forceRender="true"
    :footer="false"
    width="1100px"> -->
  <a-drawer 
    :title="title"
    :visible="visible.raw"
    v-if="visible.raw"
    @close="cancel"
    :bodyStyle="modalBodyStyle"
    :forceRender="true"
    width="800px"
    destroyOnClose
  >
    <a-spin :spinning="calculateLoading" tip="计算中">
      <a-row type="flex" align="middle" justify="space-between" class="header">
        <a-space>
          <a-input-search :allowClear="true" v-model="filterData.name" size="small" placeholder="输入名称/代码" style="width: 160px" @search="onSearch" />
          <base-list-select style="width:160px" category="nutritiontarget" placeholder="选择类型" @change="typeChange" @select="selectItem" :value="types" />
          <a-select
            @change="nutritionChange"
            style="width:160px"
            placeholder="选择养分表"
            v-model="filterData.linkId"
          >
            <a-select-option v-for="(item,index) in nutritionList" :title="item.name" :key="index" :value="item.id">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-space>
        
        <a-space v-if="(rawSelect.productType == 1)">
          <a-select :disabled="rawSelect && rawSelect.isFucCal != 1" style="width:180px" placeholder="选择方程" v-model="equationId" @change="selectEquation">
            <a-select-option v-for="(item,index) in equation" :key="index" :value="item.id">
              {{item.name}}
            </a-select-option>
          </a-select>
          <a-button :disabled="rawSelect && rawSelect.isFucCal != 1" :loading="calculateLoading" size="small" type="primary" @click="calculate">计算</a-button>
        </a-space>
      </a-row>
      <a-table
        :columns="columns"
        :data-source="list"
        :row-key="record => record.code"
        :pagination="false"
        :loading="listLoading"
        :scroll="{ x:0, y: y }"
        @change="listChange"
      >
        <template slot="nutritionValue" slot-scope="text,record">
          <span v-if="(rawSelect.productType != 1)">{{text|numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 4)}}</span>
          <div v-else>
            <span v-if="record.isAutoCal== 1">{{text || text === 0 ? text.toFixed(4) : ''}}</span>
            <cell-editor
              v-else
              :len="4" 
              :background="true" 
              :item="record" 
              name="nutritionValue" 
              @blur="target => itemChange(target,'nutritionValue')" :text="text" 
              :actions="target => update(target,record.nutritionId)"
            />
          </div>
          
        </template>
        <template slot="analysisVal" slot-scope="text,record">
          {{text|numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 4)}}
        </template>
        <template slot="val" slot-scope="text">
          {{text|numberFixed(4)}}
        </template>
        <template slot="content" slot-scope="text,record">
          {{getContent(record)}}
        </template>
        <template slot="contentPercentage" slot-scope="text,record">
          {{getContent(record) ? div(getContent(record),allVal).toFixed(4) : null}}
        </template>
      </a-table>
    </a-spin>
  <!-- </a-modal> -->
  </a-drawer>
</template>

<script>
import { nhfMixins } from '../../untils'
import CellEditor from '../editor/CellEditor.vue'
import BaseListSelect from '../select/BaseListSelect.vue'
export default {
  components: { BaseListSelect, CellEditor },
  mixins:[nhfMixins],
  data(){
    return {
      y: 500,
      cacheData:[],
      resultLoading:false,
      columns:[
        {
          dataIndex:'name',
          title:'指标名称',
          width: 140
        },
        {
          dataIndex:'code',
          title:'代码',
          width:80
        },
        {
          dataIndex:'typeName',
          title:'类型',
          width: 100
        },
        {
          dataIndex:'nutritionValue',
          scopedSlots: {customRender: 'nutritionValue'},
          title:'数值',
          width:180,         
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
          align:'center'
        },
        {
          dataIndex:'nutritionAnalysisVal',
          scopedSlots: {customRender: 'analysisVal'},
          title:'营养分析',
          sorter: (a, b) => a.nutritionAnalysisVal - b.nutritionAnalysisVal,
          width:100,
          align:'center'
        },
        {
          scopedSlots: {customRender: 'content'},
          width: 100,
          title:'养分',
          sorter: (a, b) => this.getContent(a) - this.getContent(b),
        }
      ],
      list: [],
      equation:{
        records:[]
      },
      batStatus:false,
      keyword:'',
      equationId:null,
      types:[],
      listLoading:false,
      calculateLoading:false,
      nutritionId:null,
      calculateResult:[],
      isContain:true,
      filterData:{},
      hidden:false,
      // title: '原料指标'
    }
  },
  mounted(){
    let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
    this.y = clientHeight - 180
  },
  computed:{
    title(){
      return this.rawSelect.rawName || '原料指标'
    },
    eidtorText(){
      return this.batStatus ? '取消编辑' : '批量编辑'
    },
    allVal(){
      return this.list.reduce((val, item) => val + (item.nutritionAnalysisVal === null || item.nutritionAnalysisVal === '' ? 0 : item.nutritionAnalysisVal) , 0)
    },
  },
  watch:{
    rawSelect(val){
      if(val && val.rawId) {
        this.isContain = true
        let overseasFlag = window.localStorage.getItem('overseasFlag')
        let title = overseasFlag == '1' ? (val ? val.aliasName || val.rawName : '') : (val ? val.rawName || '' : '')
        if(!title) title = '原料指标'
        this.title = title
        this.filterData.linkId = this.detail.linkId
        this.getEquationList()
        this.$nextTick(()=>{
          if(this.visible.raw)this.getList()
        })
      }
      
    },
    'visible.raw'(val){
      if(val) this.filterData.linkId = this.detail.linkId
      val ? this.getList() : this.resetList()
    },
    'filterData.name'(name){
      this.getList(name ? {name} : {})
    },
  },
  methods:{
    getContent(val){
      const {percentage=null} = this.rawSelect || {}
      return (percentage === '' || percentage === null || !val || val.nutritionAnalysisVal === '' || val.nutritionAnalysisVal === null) ? null : this.div(this.mul(val.nutritionAnalysisVal, percentage),100).toFixed(4)
    },

    selectEquation(val){
      this.equationId = val
    },

    toggleContain(isContain, list = false){
      this.$nextTick(()=>{
        this.batStatus = false
        let arrs = list || this.cacheData
        let arr = JSON.parse(JSON.stringify(arrs))
        this.list = isContain ? arr : arr.filter(i => i.isContain === "1")
      })
    },

    selectItem(val){
      if(val === undefined) {
        this.toggleContain(this.isContain,this.cacheData)
      }
    },

    async setResult(listChange,otherList){
      if(this.calculateResult.length > 0  && listChange.length > 0){
        // this.filterData = {}
        this.filterData = {linkId: this.detail.linkId}
        this.types = []
        let custFactoryStaffNutritionRawList = []
        // const featherList = this.list.records.map(i=>{
        //   const {rawId} = i
        //   let filterArray =  listChange.filter(item=>i.code === item.code)
        //   return {...i,...filterArray[0],rawId}
        // })
        // featherList.forEach(i=>{
        //     const { isContain,nutritionId,culationValue,rawId,staffId,id,factoryId,isBelongRaw } = i
        //     if(i.culationValue !== i.nutritionValue){
        //       custFactoryStaffNutritionRawList.push({isContain,factoryId,nutritionId,nutritionValue:culationValue,isBelongRaw,formulaId:this.formulaId,rawId,id,staffId })
        //     }
        // })
        listChange.forEach(el => {
          const { isContain,nutritionId,culationValue,nutritionValue,rawId,id } = el
          if(culationValue !== nutritionValue){
            custFactoryStaffNutritionRawList.push({
              nutritionId,rawId,id,isContain,
              nutritionValue: culationValue,
              isBelongRaw: !id ? '0' : '1',
              factoryId: window.localStorage.getItem('factoryId'),
              staffId: window.localStorage.getItem('staffId'),
              customId: this.detail.customId,
            })
          }
        })
        custFactoryStaffNutritionRawList = [...custFactoryStaffNutritionRawList,...otherList]
        if(custFactoryStaffNutritionRawList.length > 0){
          if(custFactoryStaffNutritionRawList.length > 1)this.listLoading = true
          await this.batUpdate({
            custFactoryStaffNutritionRawList,
          })
        }
        await this.getList({...this.currentPage})
      }
    },

    async calculate(){
      const {rawId} = this.rawSelect || {}
       const calculateResult = await this.fetchPost({
        actions:this.custRawEquationCalculateBackGround,
        loading:'calculateLoading',
        showMessage:false,
        data:{
          customId: this.detail.customId,
          equationId: this.equationId,
          rawId,
          factoryId: window.localStorage.getItem("factoryId"),
          // equationId:this.equationId,
          // factoryId:window.localStorage.getItem('factoryId'),
          // nutritionValues:[   {
          //   "code": "",
          //   "convertUnit": "",
          //   "convertUnitId": 0,
          //   "createTime": "",
          //   "createUser": 0,
          //   "culationValue": 0,
          //   "fullName": "",
          //   "id": 0,
          //   "isCal": "",
          //   "isContain": "",
          //   "isDeleted": 0,
          //   "name": "",
          //   "nutritionId": 0,
          //   "nutritionValue": 0,
          //   "rawId": 0,
          //   "status": 0,
          //   "typeCode": "",
          //   "typeName": "",
          //   "unit": "",
          //   "unitId": 0,
          //   "updateTime": "",
          //   "updateUser": 0
          // }],
          // rawId,
        }
      })
      // this.calculateResult = calculateResult
      // this.setState({rawResult:calculateResult})
      // this.toggleVisible('result')
      let {errorMsg,code} = calculateResult
      if(code === 400){
        console.log(errorMsg)
        this.$message.warning('指标数值异常，请修改后再计算。')
      }else{
        this.calculateResult = calculateResult
        this.setState({rawResult:calculateResult})
        this.toggleVisible('result')
      }
    },

    batList(res){
      let list = [...this.list]
      res.forEach((item)=>{
        const index = list.findIndex(i=>i.id === item.id)
        list.splice(index,1,{...item,editable:false})
      })
      this.list = list
    },

    async batUpdate(arg = {}){
      let custFactoryStaffNutritionRawList = this.list.map(i=>{
        const { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId,customId } = i
        return { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id ,staffId,customId}
      })
      const res = await this.fetchPost({
        actions: arg.custFactoryStaffNutritionRawList.length === 1 ? this.singleAutoUpdateStaffCustNutritionRawList : this.batchUpdateStaffNutritionRawListCustom,
        loading: arg.custFactoryStaffNutritionRawList.length > 1 ? 'listLoading' : undefined,
        data:{
          custFactoryStaffNutritionRawList,
          ...arg
        }
      })
      if(res){
        for(let item in res){
          let obj = this.list.find(el => el.code === item) || {}
          let newObj = res[item]
          if(obj && obj.code){
            obj.nutritionValue = newObj.nutritionValue
            obj.nutritionAnalysisVal = newObj.nutritionValue || newObj.nutritionValue === 0 ? newObj.nutritionValue : obj.baseNutritionVal
            obj.id = newObj.id
          }
        }
        this.$emit('refresh');
      }

      return res
    },

    async staffUpdate(arg = {}){
      const res = await this.fetchPost({
        // actions:this.singleUpdateStaffNutritionRawList,
        actions: this.singleAutoUpdateStaffNutritionRawList,
        data:{
          custFactoryStaffNutritionRawList: this.list.map(i=>{
            const { code,createTime,createUser,factoryId,id,isBelongRaw,isDeleted,name,nutritionId,nutritionValue,rawId,staffId,status,unit,updateTime,updateUser} = i
            return {  code,createTime,createUser,factoryId,id,isBelongRaw,isDeleted,name,nutritionId,nutritionValue,rawId,staffId,status,unit,updateTime,updateUser}
          }),
          ...arg
        }
      })
      let {data,success} = res || {}
      if(success){
        for(let item in data){
          let obj = this.list.find(el => el.code === item) || {}
          let newObj = data[item]
          if(obj && obj.code){
            obj.nutritionValue = newObj.nutritionValue
            obj.id = newObj.id
          }
        }
      }
      // this.getList()
      return res
    },

    itemChange(val, column) {
      const {nutritionId} = val
      let newData = [...this.list]
      let target = newData.filter(item => nutritionId === item.nutritionId)[0]
      // let dm = newData.filter(i=>i.name === 'DM')[0]
      // let moisture = newData.filter(i=>i.name === 'Moisture')[0]

      if (target) {
        let value = val[column]
        const isNull = value === '' || value === null
        const baseVal = target['baseNutritionVal'] === '' || target['baseNutritionVal'] === null ? null : target['baseNutritionVal']
        target['nutritionAnalysisVal'] = isNull ?  baseVal  : this.checkDm(value)
        target[column] = value

        // if(target.name === 'DM') {
        //   moisture.nutritionValue = isNull ? null : 100 - value
        //   moisture.nutritionAnalysisVal = isNull ? moisture.baseNutritionVal : 100 - this.checkDm(value)
        //   moisture.isChange = true
        // }
        // if(target.name === 'Moisture') {
        //   dm.nutritionValue = isNull ?  null : 100 - value
        //   dm.nutritionAnalysisVal = isNull ? dm.baseNutritionVal : 100 - this.checkDm(value)
        //   dm.isChange = true
        // }
        
        this.list = newData
      }
    },
    checkDm(val){
      let start = this.detail ? this.detail.moistureVolatilizeStart : 0
      return start > 0  ? val / ((100 - start )/100)  : val
    },
    editorItem(id){
      const newData = [...this.list]
      const target = newData.filter(item => id === item.nutritionId)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list = newData
      }
    },
    // update(target,key){
    //   const newData = [...this.list]
    //   const newCacheData = [...this.cacheData]
    //   const targetCache = newCacheData.filter(item => key === item.nutritionId)[0]

    //   if (target && targetCache) {
    //     delete target.editable
    //     this.list.records = newData
    //     Object.assign(targetCache, target)
    //     this.cacheData = newCacheData
    //     let custFactoryStaffNutritionRawList = [target]
        
    //     return this.staffUpdate({
    //       custFactoryStaffNutritionRawList:custFactoryStaffNutritionRawList.map( item =>{
    //         const { code,createTime,createUser,factoryId,id,isBelongRaw,isDeleted,name,nutritionId,nutritionValue,rawId,staffId,status,unit,updateTime,updateUser} = item
    //         return {  code,createTime,createUser,factoryId,id,isBelongRaw,isDeleted,name,nutritionId,nutritionValue,rawId,staffId,status,unit,updateTime,updateUser}
    //       })
    //     })
    //   }
    // },
    update(target,key){
      const newData = [...this.list]
      const newCacheData = [...this.cacheData]
      const targetCache = newCacheData.filter(item => key === item.nutritionId)[0]
      if (target && targetCache) {
        delete target.editable
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        target.customId = this.detail.customId
        target.rawId = this.rawSelect.rawId
        target.factoryId = window.localStorage.getItem('factoryId')
        let custFactoryStaffNutritionRawList = [target]
        // const value = target.nutritionValue
        // if(target.name === 'DM') {
        //   custFactoryStaffNutritionRawList.push({...moisture, nutritionValue:value || value === 0 ? 100 - value : null,})
        //   moisture.nutritionValue = value || value === 0 ? 100 - value : null
        // }
        // if(target.name === 'Moisture') {
        //   custFactoryStaffNutritionRawList.push({...dm, nutritionValue:value || value === 0 ? 100 - value : null,})
        //   dm.nutritionValue = value || value === 0 ? 100 - value : null
        // }
        this.list = newData
        return this.batUpdate({
          custFactoryStaffNutritionRawList:custFactoryStaffNutritionRawList
        })
      }
    },

    searchChange(){
      this.list = JSON.parse(JSON.stringify([...this.cacheData]))
    },

    onSearch(){
      let arr = [...this.cacheData]
      let key = this.keyword.toLocaleLowerCase()
      if(this.keyword !== '') this.list = arr.filter(i => i.name.toLocaleLowerCase().indexOf(key)!= -1 || i.code.toLocaleLowerCase().indexOf(key)!= -1)
      this.toggleContain(this.isContain,this.list)
    },

    typeChange(val){
      this.types = val
      this.filterData.typeId = [...val].pop()
      this.$nextTick(()=>{
        this.getList()
      })
    },
    nutritionChange(){
      this.getList()
    },

    async getEquationList(){
      const {data} = await this.fetchGet({
        actions:this.equationList,
        name:'equation',
        data:{
          size:200
        }
      })
      data && data.length && this.selectEquation(data[0].id)
    },

    async getList(arg= {}){
      if(this.rawSelect){
        let params = {
          rawId:this.rawSelect.rawId,
          factoryId:this.factoryId,
          customId: this.detail.customId,
          staffId: window.localStorage.getItem('staffId'),
          productId: this.rawSelect.productId,
          formulaId:this.formulaId,
          productType: this.rawSelect.productType,
          query: {
            size:1000,
            current: 1
          }
          // formulaId:this.formulaId
        }
        if(this.types.length) params.typeId=[...this.types].pop()
        if(this.keyword) params.keyword = this.keyword
        let apiFeild = 'getCustomProMoistureVolatilizePage'
        let methodFeild = 'fetchPost'
        if(this.rawSelect.productType == 1) apiFeild = 'getCustFactoryStaffNutritionRawMoistureVolatilizePage'
        const res = await this[methodFeild]({
          actions:this[apiFeild],
          // isList:true,
          loading:'listLoading',
          // name:'list',
          showMessage: false,
          data:{
            ...params,
            ...this.filterData,
            ...arg,
          }
        })
        this.cacheData = JSON.parse(JSON.stringify(res || []))
        this.list = res.filter(el => el.typeId != '1386613070176682199')
        this.$nextTick(()=>{
          this.toggleContain(this.isContain,this.list)
        })
        return res
      }
    },

    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
    
    ok(){
      this.toggleVisible('raw')
    },
    
    cancel(){
      this.toggleVisible('raw')
      this.$emit('refreshNutrition')
    },

    resetList(){
      this.keyword = ''
      this.types = []
      this.filterData ={}
      this.cleanSelect()
    },
  }
}
</script>
<style lang="scss" scoped>
  .header{
    padding:0 0 15px;
  }
</style>
